// Which navigation chrome the parent area uses (FR-005, FR-006; research R7; routes.md "Navigation
// chrome per address"). The one justified platform difference in the chrome: Android is always the
// mobile chrome; the web switches to the desktop header at tokens.breakpoint.desktop (1024 px).
import { useWindowDimensions } from "react-native";

import { usePlatform } from "@/session/platform";
import type { Platform } from "@/session/types";
import { tokens } from "@/theme/tokens";

export type ChromeKind = "mobile" | "desktop";

export function chromeKindFor(platform: Platform, width: number): ChromeKind {
  return platform === "web" && width >= tokens.breakpoint.desktop
    ? "desktop"
    : "mobile";
}

export function useChromeKind(): ChromeKind {
  const { width } = useWindowDimensions();
  return chromeKindFor(usePlatform(), width);
}
